Backbone = require 'backbone'
Backbone.$ = $

class SupportMainContentWrapperView extends Backbone.View
  className: 'help-wizard-content'

  initialize: ->

  render: (renderContents)->
    renderContents(@$el)

module.exports = SupportMainContentWrapperView
